export default __webpack_public_path__ + "static/media/tpp-wellness-screen-allowance.264c543f.svg";